const MyDeploymentsIcon = () => {
    return (
        <div
            className="MuiListItemIcon-root"
            style={{
                width: "24px",
                height: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 26 26"
                fill="none"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.1427 7.93286C11.6145 7.93286 12.0672 8.01199 12.4888 8.15923L14.3187 4.33603C12.621 2.82055 13.6997 0 15.9713 0C18.1577 0 19.2976 2.66444 17.724 4.23885C17.2092 4.75369 16.4851 5.03013 15.7219 4.95403L13.8199 8.92749C14.502 9.51645 14.9847 10.3208 15.166 11.2313L18.4362 11.2122C19.0221 9.14785 21.6322 8.44777 23.1675 9.98321C24.9493 11.7651 23.6804 14.8231 21.1634 14.8231C19.8754 14.8231 18.7656 13.9577 18.4312 12.7447L15.18 12.7637C15.0077 13.7223 14.502 14.5707 13.7798 15.1777L15.5416 18.1896C18.0595 17.7098 19.715 20.7948 17.8863 22.6228C16.2307 24.2785 13.4092 23.0825 13.4092 20.7668C13.4092 20.0446 13.7067 19.3785 14.1854 18.9067L12.4427 15.9269C11.388 16.2785 10.2322 16.1853 9.2556 15.6775L7.40469 18.2337C9.43588 20.4252 7.87442 24 4.88674 24C1.83787 24 0.301503 20.2971 2.45892 18.1385C3.41543 17.182 4.85669 16.8675 6.13573 17.3673L8.04872 14.7249C6.96601 13.4798 6.72966 11.694 7.47081 10.2055L5.21727 8.49171C3.2652 10.3688 0 8.9785 0 6.27008C0 3.53358 3.32323 2.15431 5.26035 4.09152C6.0586 4.88983 6.36808 6.07677 6.02555 7.18367L8.39727 8.9866C9.1234 8.33253 10.0861 7.93286 11.1427 7.93286Z"
                    fill="currentcolor"
                />
            </svg>
        </div>
    );
};

export default MyDeploymentsIcon;
